import { Link, useNavigate } from "react-router-dom";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, H6, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import {
  CreateAccount,
  DoNotAccount,
  EmailAddress,
  ForgotPassword,
  Href,
  Password,
  RememberPassword,
  SignIn,
  SignInAccount,
  SignInWith,
} from "../../utils/Constant";
import { useState } from "react";
import { toast } from "react-toastify";
import SocialApp from "./SocialApp";
import apiRequestHelper from "../../utils/apiRequestHelper";
import { useAuth } from "../../context/AuthContext";
// import loginUser

const ForgetPassword = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { loginUser } = useAuth();
  const SimpleLoginHandle = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!email) {
      // alert("Please enter your email address.");
      toast.error("Please enter your email address.");
      return;
    }
    try {
      const response = await apiRequestHelper.post(
        "/auth/request-reset-password",
        {
          email,
        },
      );
      // alert(response.data.messages[0].message);
      toast.success(response?.data?.messages?.[0]?.message || "");
      // alert("Email sent successfully. Please check your email for further instructions.");
      setEmail("");
      navigate("/login");
    } catch (error: unknown) {
      let err = error as any; // eslint-disable-line no-console
      // alert(err.response?.data?.messages?.[0]?.message || "An error occurred");
      toast.error(
        err.response?.data?.messages?.[0]?.message || "An error occurred",
      );
    }
  };

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <video
              className="video-bg"
              playsInline
              autoPlay
              loop
              muted
              preload="auto"
            >
              <source src="/assets/video/video-bg.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div>
              <div>
                <Link className="logo text-center position-relative" to={Href}>
                  <Image
                    className="img-fluid for-dark mx-auto"
                    style={{ width: "220px" }}
                    src={dynamicImage("logo.png")}
                    alt="looginpage"
                  />
                  <Image
                    className="img-fluid for-light mx-auto"
                    style={{ width: "220px" }}
                    src={dynamicImage("logo.png")}
                    alt="looginpage"
                  />
                </Link>
              </div>
              <div className="login-main position-relative">
                <Form
                  className="theme-form"
                  onSubmit={(e) => SimpleLoginHandle(e)}
                >
                  <H4>Forgot Password</H4>
                  <P>{"Enter your email "}</P>
                  <FormGroup>
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input
                      type="email"
                      required
                      placeholder="Email"
                      value={email}
                      name="email"
                      onChange={(event) => setEmail(event.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="mb-0 form-sub-title position-relative">
                    <div className="text-end mt-3">
                      <Btn color="primary" block className="w-100">
                        Submit
                      </Btn>
                    </div>
                  </FormGroup>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgetPassword;
